import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Plan } from 'app/models/plan';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PlanPieceService {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }
  
  private refreshData = new Subject<void>();
  
  get refreshNeeded() {
    return this.refreshData;
  }

  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur PlanPieceService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  // Get all plans (global – not used for piece-specific list)
  getAllPlans(): Observable<Plan[]> {
    const headers = this.getHeaders();
    return this.http.get<Plan[]>(
      this.base_path + 'projets/piece/plan/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Get single plan by ID
  getPlan(id: number): Observable<Plan> {
    const headers = this.getHeaders();
    return this.http.get<Plan>(
      this.base_path + 'projets/piece/plan/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Create a plan for a specific piece
  createPlan(pieceId: number, plan: Plan): Observable<Plan> {
    const headers = this.getHeaders();
    return this.http.post<Plan>(
      this.base_path + 'projets/piece/plan/add/' + pieceId,
      JSON.stringify(plan),
      { headers }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError)
    );
  }

  // Update a plan
  updatePlan(id: number, plan: Plan): Observable<Plan> {
    const headers = this.getHeaders();
    return this.http.put<Plan>(
      this.base_path + 'projets/piece/plan/update/' + id,
      JSON.stringify(plan),
      { headers }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError)
    );
  }

  // Delete a plan
  deletePlan(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(
      this.base_path + 'projets/piece/plan/delete/' + id,
      { 
        headers,
        responseType: 'text'
      }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError)
    );
  }
}